import { useState, useEffect, useRef } from 'react'

interface MousePosition {
  x: number
  y: number
}

export const useMousePosition = () => {
  const [mousePosition, setMousePosition] = useState<MousePosition>({ x: 0, y: 0 })
  const throttleRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    const handleMouseMove = (event: MouseEvent) => {
      // 쓰로틀링으로 성능 최적화 (16ms = 60fps)
      if (throttleRef.current) return
      
      throttleRef.current = setTimeout(() => {
        setMousePosition({
          x: event.clientX,
          y: event.clientY
        })
        throttleRef.current = null
      }, 16)
    }

    window.addEventListener('mousemove', handleMouseMove)

    return () => {
      window.removeEventListener('mousemove', handleMouseMove)
      if (throttleRef.current) {
        clearTimeout(throttleRef.current)
      }
    }
  }, [])

  // 화면을 3등분하여 위치 결정
  const getScreenRegion = () => {
    const screenWidth = window.innerWidth
    const thirdWidth = screenWidth / 3

    if (mousePosition.x < thirdWidth) {
      return 'left'
    } else if (mousePosition.x < thirdWidth * 2) {
      return 'center'
    } else {
      return 'right'
    }
  }

  return {
    mousePosition,
    screenRegion: getScreenRegion()
  }
}
